import React from 'react'
import classNames from 'classnames'

import Tooltip from '../../tooltip/Tooltip'
import './IconButton.less'

export interface IIconButtonProps {
  icon: React.ReactElement<any>
  hint?: string
  disabled?: boolean
  color?: 'light' | 'medium' | 'red'
  className?: string
  style?: any
  onClick?: (ev: React.MouseEvent<HTMLSpanElement>) => void
  dataTest?: string
}

/**
 * @deprecated
 * use chakra ButtonIcon from ./ButtonChakra.tsx
 */
export const IconButton: React.FC<IIconButtonProps> = ({
  className,
  color = 'light',
  hint,
  dataTest = 'IconButton',
  icon,
  ...restProps
}) => {
  const cssClasses = classNames('IconButton', className, color, {
    hint: hint
  })

  return (
    <span data-test={dataTest} className={cssClasses} {...restProps}>
      <Tooltip disabled={!hint} text={hint}>
        {icon}
      </Tooltip>
    </span>
  )
}
export default IconButton
